import type { ReactNode } from 'react';
import { SearchBar } from './SearchBar';
import { ActivityBell } from './ActivityBell';
import { useSidebar } from './AppShell';

interface Props {
  title: string;
  searchValue: string;
  onSearchChange: (v: string) => void;
  onNewTask?: () => void;
  onShowShortcuts?: () => void;
  leadingSlot?: ReactNode;
  children?: ReactNode;
}

export function ViewHeader({
  title,
  searchValue,
  onSearchChange,
  onNewTask,
  onShowShortcuts,
  leadingSlot,
}: Props) {
  const { toggle } = useSidebar();
  return (
    <header className="scope-view-header">
      <button
        type="button"
        className="sidebar-toggle"
        onClick={toggle}
        aria-label="Open menu"
        title="Menu"
      >
        <span aria-hidden="true">☰</span>
      </button>
      <h1>{title}</h1>
      <div className="view-header-tools">
        {leadingSlot}
        <div className="view-header-search">
          <SearchBar value={searchValue} onChange={onSearchChange} placeholder="Search…" />
        </div>
        {onNewTask && (
          <button className="outlined" onClick={onNewTask}>+ New task</button>
        )}
        {onShowShortcuts && (
          <button
            className="outlined"
            onClick={onShowShortcuts}
            title="Keyboard shortcuts (?)"
          >
            Shortcuts
          </button>
        )}
        <ActivityBell />
      </div>
    </header>
  );
}
